module.exports = __webpack_public_path__ + "static/media/DK4050_03.94318c7a.jpg";